import { useState } from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Services from "../../../../API/PIservices";
import { useLegalFormStepsContext } from "../../../../context/LegalFormContext";
import Button from "../../../../shared/button/button";
import { ButtonWrapperStyles } from "../../../../shared/button/ButtonWrapperStyles";
import Loader from "../../../../shared/loaders/simpleLoader";
import ApprovedIcon from "../../../../assets/icons/stepsIcons/ApprovedIcon";
import { AgreementContainer } from "../../../common/styledComponents/agreementStyles/agreement.style";
import { SERVICE_TYPES } from "../../../../utils/constants/fieldErrors";
import { useGlobalContext } from "../../../../context/globalContext";
import {
  mobileSessionStorage,
  setMobileSessionStorage,
} from "../../../../utils/helpers/mobileSessionStorage";
import { useParams } from "react-router-dom";
import { rejectEvent } from "../../../../utils/helpers/successEvent";
import SafeHtml from "../../../common/SafeHtml";

const Agreement = () => {
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(true);
  const { catchError } = useGlobalContext();
  const { nextStep } = useLegalFormStepsContext();
  const params = useParams();
  const mobile = params?.mobile?.toLowerCase() === "mobile";

  const handleReject = () => {
    document.dispatchEvent(rejectEvent);
    if (!mobile) {
      if (i18n.language === "ka") {
        window.open("http://www.procreditbank.ge/ge");
      } else {
        window.open("http://www.procreditbank.ge/en");
      }
    }
  };

  const [agreements, setAgreements] = useState([]);

  useEffect(() => {
    setLoading(true);
    Services.getAgreements(i18n.language, SERVICE_TYPES.Legal)
      .then((response) => setAgreements(response.data))
      .catch((err) => catchError(err, { withoutRedirect: true }))
      .finally(() => setLoading(false));
  }, [i18n.language]);

  useEffect(() => {
    if (params?.mobile?.toLowerCase() === "mobile" || mobileSessionStorage)
      setMobileSessionStorage(true);
  });
  return (
    <AgreementContainer>
      {loading ? (
        <Loader />
      ) : (
        <div className="agreementWrapper">
          {/* <InfoCard className="mb-[60px]" text={t('confirmationText')} /> */}
          {agreements.map((agreement, index) => (
            <div className={"agreementTextWrapper"} key={index}>
              <div className="mr-4">
                <ApprovedIcon />
              </div>

              <SafeHtml as="span" html={agreement} />
            </div>
          ))}
          <ButtonWrapperStyles>
            <Button
              variant={"inherit"}
              style={{ marginRight: "5px" }}
              onClick={handleReject}
            >
              {t("Cancel")}
            </Button>
            <Button variant={"primary"} onClick={nextStep} type="submit">
              {t("confirmation")}
            </Button>
          </ButtonWrapperStyles>
        </div>
      )}
    </AgreementContainer>
  );
};

export default Agreement;
